import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/Home.vue";
import About from "../components/pages/About.vue";
import Contact from "../components/pages/Contact.vue";
import Casting from "../components/pages/Casting.vue";
import ArticlesList from "../components/pages/articles/List.vue";
import ArticlesItem from "../components/pages/articles/Item.vue";
import PortfolioList from "../components/pages/portfolio/List.vue";
import PortfolioItem from "../components/pages/portfolio/Item.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Página Inicial",
    component: Home,
  },
  {
    path: "/sobre",
    name: "Sobre",
    component: About,
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contact,
  },
  {
    path: "/casting",
    name: "Casting",
    component: Casting,
  },
  {
    path: "/blog",
    name: "Blog",
    component: ArticlesList,
  },
  {
    path: "/blog/:item",
    name: "Blog",
    component: ArticlesItem,
  },
  {
    path: "/equipe/:item",
    name: "Portfólio",
    component: PortfolioList,
  },
  {
    path: "/portfolio",
    name: "Portfólio",
    component: PortfolioList,
  },
  {
    path: "/portfolio/:item",
    name: "Portfólio",
    component: PortfolioItem,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
